<div class="row">
    <div class="col-md-12">
        <h5>Custom Branding (Optional)</h5>
        <p>Apply your logo, icon and color palette to the site to make it recognizable to your member base. This can be changed later in settings.</p>
    </div>
    <div class="col-md-6">
        <h5 class="text-center">Logo</h5>
        <app-file-upload [maxFiles]="1" [allowMultiple]="false" [acceptedTypes]="'image/*'" (fileSelected)="updateLogo($event)"></app-file-upload>
    </div>
    <div class="col-md-6">
        <h5 class="text-center">Icon</h5>
        <app-file-upload [maxFiles]="1" [allowMultiple]="false" [acceptedTypes]="'image/*'" (fileSelected)="updateIcon($event)"></app-file-upload>
    </div>
</div>

